import { cva } from 'class-variance-authority';

export const accordionClasses = cva(['w-full gap-4 border-b border-solid border-[#E6E6E6] pb-4'], {
  variants: {
    underline: {
      true: 'border-b border-solid border-[#E6E6E6]',
      false: 'border-b-0'
    }
  }
});

export const accordionHeaderClasses = cva([
  'font-nista-grotesk leading-sm flex cursor-pointer items-center justify-between text-sm font-medium tracking-wide'
]);

export const accordionIconClasses = cva(
  [
    'h-4 w-4 shrink-0 text-sm font-medium tracking-wide transition-transform duration-200 ease-in-out'
  ],
  {
    variants: {
      isOpen: {
        true: 'rotate-180'
      }
    }
  }
);

export const accordionContentClasses = cva(
  ['overflow-hidden transition-all duration-200 ease-in-out'],
  {
    variants: {
      isOpen: {
        true: 'max-h-96 pt-4',
        false: 'max-h-0 pt-0'
      }
    }
  }
);
